<template>
  <div id="app" :style="{height:`${this.defaultPosition.x}px`}">
    <keep-alive>
      <router-view name="header" />
    </keep-alive>

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <transition name="fade" mode="out-in">
      <router-view v-if="!$route.meta.keepAlive" />
    </transition>

    <keep-alive>
      <router-view name="footer" />
    </keep-alive>
  </div>
</template>
<style>

.block {
    border-radius: 7px;
    width: 70%;
    background-color: #fff;
    padding: .3rem;
  }
.buttonListItem{
  display: block;
  margin: 15px auto;
  width: 80%;
  font-size: 1rem;
}
.van-button--info {
  color: rgb(108, 117, 125);
  background-color: #FFFFFF;
  border: 1px solid rgb(108, 117, 125);
}
</style>
<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
<script>
import {mapGetters} from 'vuex'
export default {
  data() {
    return {
      defaultPosition: {
        x: window.innerHeight
        // y: 370,
      }
    };
  },
  computed:{
    ...mapGetters(['liffUserData'])
  },
  async created() {
    this.initAllCompetesData();
  },
  methods: {
    // async initLiff() {
    //   await this.$store.dispatch("initLiffUserData");
    // },
    initAllCompetesData() {
      this.$store.dispatch("initAllCompetesData");
    },

    
  }
};
</script>
